<div class="flex flex-col gap-12 animate-fadeIn">
  <!-- Section 1: Agenda Configuration (Categories) -->
  <div class="flex flex-col gap-6">
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div class="flex flex-col gap-1">
        <h3 class="text-xs font-black uppercase tracking-[0.2em] text-slate-500">{{ 'agenda_config_title' | translate }}</h3>
      </div>
      <app-button *hasPermission="'Configurações:create'"
        label="{{ 'agenda_add_color' | translate }}"
        icon="pi pi-plus"
        variant="primary"
        (onClick)="openTypeModal()">
      </app-button>
    </div>

    <app-prime-table
      [columns]="typeColumns"
      [data]="typeColors"
      [loading]="loadingTypes"
      [templates]="typeTemplates"
      [paginator]="false">
    </app-prime-table>

    <!-- Templates for Types Table -->
    <ng-template #typeColorTimeTpl let-item>
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-lg border border-slate-100 shadow-sm" [style.backgroundColor]="item.color_time"></div>
        <span class="text-xs font-mono text-slate-500">{{ item.color_time }}</span>
      </div>
    </ng-template>

    <ng-template #typeBgTimeTpl let-item>
       <div class="flex items-center gap-3">
         <div class="w-8 h-8 rounded-lg border border-slate-100 shadow-sm" [style.backgroundColor]="item.bg_time"></div>
         <span class="text-xs font-mono text-slate-500">{{ item.bg_time }}</span>
       </div>
    </ng-template>
    
    <ng-template #typeActionsTpl let-item>
       <div class="flex justify-end gap-2">
         <button *hasPermission="'Configurações:edit'" (click)="openTypeModal(item)" class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
         </button>
         <button *hasPermission="'Configurações:delete'" (click)="deleteType(item.id)" class="p-2 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all" [title]="'delete' | translate">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
         </button>
       </div>
    </ng-template>
  </div>

  <!-- Section 2: Status Colors -->
  <div class="flex flex-col gap-6">
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div class="flex flex-col gap-1">
        <h3 class="text-xs font-black uppercase tracking-[0.2em] text-slate-500">{{ 'agenda_status_title' | translate }}</h3>
      </div>
      <app-button *hasPermission="'Configurações:create'"
        label="{{ 'agenda_add_color' | translate }}"
        icon="pi pi-plus"
        variant="primary"
        (onClick)="openStatusModal()">
      </app-button>
    </div>

    <app-prime-table
      [columns]="statusColumns"
      [data]="statusColors"
      [loading]="loadingStatuses"
      [templates]="statusTemplates"
      [paginator]="false">
    </app-prime-table>

    <!-- Templates for Status Table -->
    <ng-template #statusNameTpl let-item>
      <span class="text-sm text-slate-700">{{ getStatusLabel(item.status_name) }}</span>
    </ng-template>

    <ng-template #statusColorTextTpl let-item>
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-lg border border-slate-100 shadow-sm" [style.backgroundColor]="item.color_text"></div>
        <span class="text-xs font-mono text-slate-500">{{ item.color_text }}</span>
      </div>
    </ng-template>

    <ng-template #statusBgCardTpl let-item>
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-lg border border-slate-100 shadow-sm" [style.backgroundColor]="item.bg_card"></div>
        <span class="text-xs font-mono text-slate-500">{{ item.bg_card }}</span>
      </div>
    </ng-template>

    <ng-template #statusActionsTpl let-item>
      <div class="flex justify-end gap-2">
        <button *hasPermission="'Configurações:edit'" (click)="openStatusModal(item)" class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
        </button>
        <button *hasPermission="'Configurações:delete'" (click)="deleteStatus(item.id)" class="p-2 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all" [title]="'delete' | translate">
           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
        </button>
      </div>
    </ng-template>
  </div>
</div>

<!-- Type Modal -->
<p-dialog 
  [(visible)]="showTypeModal" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false"
  [header]="isEditType ? ('agenda_edit_category' | translate) : ('agenda_new_category' | translate)"
  [style]="{ width: '100%', maxWidth: '28rem' }"
  styleClass="p-0"
  (onHide)="closeTypeModal()">

  <ng-template pTemplate="content">
    <form [formGroup]="typeForm" class="flex flex-col gap-4 pt-4">
      <!-- Category Name -->
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-slate-700">{{ 'agenda_category_name' | translate }} <span class="text-red-500">*</span></label>
        <input type="text" pInputText formControlName="name" class="w-full h-12" [placeholder]="'agenda_name_placeholder' | translate">
      </div>

      <!-- Time Text Color -->
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-medium text-slate-700">{{ 'agenda_time_text_color' | translate }} <span class="text-red-500">*</span></label>
        <div class="flex items-center gap-6 mt-1 h-12">
          <!-- Option 1: Branco -->
          <div class="flex items-center gap-2">
            <p-radioButton 
              name="color_time" 
              value="#FFFFFF" 
              formControlName="color_time"
              inputId="timeColorWhite">
            </p-radioButton>
            <label for="timeColorWhite" class="text-xs font-semibold text-slate-600 flex items-center gap-2 cursor-pointer select-none">
              <span class="w-4 h-4 rounded border border-slate-200 shadow-sm bg-white inline-block"></span>
              {{ 'color_white' | translate }} (#FFFFFF)
            </label>
          </div>

          <!-- Option 2: Preto -->
          <div class="flex items-center gap-2">
            <p-radioButton 
              name="color_time" 
              value="#000000" 
              formControlName="color_time"
              inputId="timeColorBlack">
            </p-radioButton>
            <label for="timeColorBlack" class="text-xs font-semibold text-slate-600 flex items-center gap-2 cursor-pointer select-none">
              <span class="w-4 h-4 rounded border border-slate-200 shadow-sm bg-black inline-block"></span>
              {{ 'color_black' | translate }} (#000000)
            </label>
          </div>
        </div>
      </div>

      <!-- Time Background Color -->
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-slate-700">{{ 'agenda_time_bg_color' | translate }} <span class="text-red-500">*</span></label>
        <div class="flex items-center gap-3">
          <p-colorPicker 
            [ngModel]="getCleanHex(typeForm.get('bg_time')?.value)" 
            (ngModelChange)="updateHex('bg_time', $event, typeForm)"
            [ngModelOptions]="{standalone: true}"
            appendTo="body"
            inputStyleClass="!w-10 !h-10 !rounded-lg !border-slate-200 !shadow-sm !cursor-pointer">
          </p-colorPicker>
          <input type="text" pInputText formControlName="bg_time" 
            (blur)="formatInputHex('bg_time', typeForm)"
            class="flex-1 h-12 !font-mono !uppercase" 
            placeholder="#000000">
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-end gap-2 pb-2">
      <app-button 
        [label]="'common_cancel' | translate" 
        variant="secondary" 
        (onClick)="closeTypeModal()">
      </app-button>
      <app-button 
        [label]="isEditType ? ('agenda_save' | translate) : ('agenda_add' | translate)" 
        [disabled]="typeForm.invalid"
        (onClick)="submitType()">
      </app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Status Modal -->
<p-dialog 
  [(visible)]="showStatusModal" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false"
  [header]="isEditStatus ? ('agenda_edit_color' | translate) : ('agenda_status_title' | translate)"
  [style]="{ width: '100%', maxWidth: '28rem' }"
  styleClass="p-0"
  (onHide)="closeStatusModal()">

  <ng-template pTemplate="content">
    <form [formGroup]="statusForm" class="flex flex-col gap-4 pt-4">
      <!-- Status Selection -->
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-slate-700">{{ 'agenda_status' | translate }} <span class="text-red-500">*</span></label>
        <p-select 
          formControlName="appointment_status_id" 
          [options]="getAvailableStatuses()" 
          optionLabel="label"
          optionValue="id"
          [placeholder]="'agenda_select_status' | translate"
          class="w-full"
          styleClass="h-12"
          appendTo="body">
        </p-select>
      </div>

      <!-- Text Color -->
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-medium text-slate-700">{{ 'agenda_text_color' | translate }} <span class="text-red-500">*</span></label>
        <div class="flex items-center gap-6 mt-1 h-12">
          <!-- Option 1: Branco -->
          <div class="flex items-center gap-2">
            <p-radioButton 
              name="color_text" 
              value="#FFFFFF" 
              formControlName="color_text"
              inputId="textColorWhite">
            </p-radioButton>
            <label for="textColorWhite" class="text-xs font-semibold text-slate-600 flex items-center gap-2 cursor-pointer select-none">
              <span class="w-4 h-4 rounded border border-slate-200 shadow-sm bg-white inline-block"></span>
              {{ 'color_white' | translate }} (#FFFFFF)
            </label>
          </div>

          <!-- Option 2: Preto -->
          <div class="flex items-center gap-2">
            <p-radioButton 
              name="color_text" 
              value="#595959" 
              formControlName="color_text"
              inputId="textColorBlack">
            </p-radioButton>
            <label for="textColorBlack" class="text-xs font-semibold text-slate-600 flex items-center gap-2 cursor-pointer select-none">
              <span class="w-4 h-4 rounded border border-slate-200 shadow-sm bg-[#595959] inline-block"></span>
              {{ 'color_black' | translate }} (#595959)
            </label>
          </div>
        </div>
      </div>

      <!-- Card Color -->
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-slate-700">{{ 'agenda_card_color' | translate }} <span class="text-red-500">*</span></label>
        <div class="flex items-center gap-3">
          <p-colorPicker 
            [ngModel]="getCleanHex(statusForm.get('bg_card')?.value)" 
            (ngModelChange)="updateHex('bg_card', $event, statusForm)"
            [ngModelOptions]="{standalone: true}"
            appendTo="body"
            inputStyleClass="!w-10 !h-10 !rounded-lg !border-slate-200 !shadow-sm !cursor-pointer">
          </p-colorPicker>
          <input type="text" pInputText formControlName="bg_card" 
            (blur)="formatInputHex('bg_card', statusForm)"
            class="flex-1 h-12 !font-mono !uppercase" 
            placeholder="#000000">
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-end gap-2 pb-2">
      <app-button 
        [label]="'common_cancel' | translate" 
        variant="secondary" 
        (onClick)="closeStatusModal()">
      </app-button>
      <app-button 
        [label]="isEditStatus ? ('agenda_save' | translate) : ('agenda_add' | translate)" 
        [disabled]="statusForm.invalid"
        (onClick)="submitStatus()">
      </app-button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{ width: '450px' }" appendTo="body" [closable]="true" styleClass="text-sm">
</p-confirmDialog>
